import React, { useState } from "react";
import './sdSwitch.scss';

function SDSwitch (props) {
    const [on, setOn] = useState(props.status || false);

    function click () {
        setOn(!on);

        if (props.onSet) {
            props.onSet(!on);
        }
    }

    return (
        <div className={`switchBody ${on ? 'switchOn': 'switchOff'}`} onClick={() => click()}>
            <div className={`main`}>
            </div>
        </div>
    )
}

export default SDSwitch;